import InputBase from './InputField';

export const InputField = InputBase;

export default InputField;
